import { DOMcreateElement, DOMcreateFragment } from '../typescript/TSXDomParse';
import TicketCartLineItem from './TicketCartLineItem';
import TicketCommitButton from './TicketCommitButton';
/**
 * TicketCart.
 *
 * author: nick.arcuri@spartan.com
 *
 * @param {TSCookie} data
 */
export default function TicketCart(data) {
    /**
     * close.
     *
     * On click, close ticket cart modal/overlay
     *
     */
    var close = function () {
        var parent = document.getElementById('race-cart-wrapper');
        parent.classList.remove('show-cart');
        var overlay = document.querySelector('.ticket-cart__overlay');
        if (overlay.classList.contains('show')) {
            overlay.classList.remove('show');
        }
        else {
            overlay.classList.add('show');
        }
    };
    return (DOMcreateElement(DOMcreateFragment, null,
        DOMcreateElement("div", { id: "ticket-cart" },
            DOMcreateElement("div", { className: "ticket-cart__header" },
                DOMcreateElement("p", null,
                    "Event Cart (",
                    data.length,
                    ")"),
                DOMcreateElement("button", { onClick: close },
                    DOMcreateElement("i", { className: "icon-close" }))),
            DOMcreateElement("div", { className: "ticket-cart__body" }, data.map(function (ticket, index) { return (DOMcreateElement(TicketCartLineItem, { key: index, lineItem: ticket })); })),
            DOMcreateElement("div", { className: "ticket-cart__footer" },
                DOMcreateElement(TicketCommitButton, { data: data })))));
}
